import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Container, Row, Form, Button, Col, Accordion, Card } from "react-bootstrap";

const FormPersonal = ({ defaultValues, objObrasPersonal, submissionHandler }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Container fluid>
        <Row xs={1} lg={2}>
          {Object.keys(objObrasPersonal).map((tipoObraPersonal) => {
            return (
              <Col>
                <Accordion defaultActiveKey="0" className="mb-2">
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0">
                      {objObrasPersonal[tipoObraPersonal]}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        <Form.Row>
                          <Form.Group className={"d-none"}>
                            <Form.Control name={`${tipoObraPersonal}.type`} value={tipoObraPersonal} {...register(`${tipoObraPersonal}.type`, {})} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} md controlId={`${tipoObraPersonal}-nPeopleM`}>
                            <Form.Label>{"Nº de varones"}</Form.Label>
                            <Form.Control
                              name={`${tipoObraPersonal}.nPeopleM`}
                              type="number"
                              isInvalid={errors[tipoObraPersonal] && errors[tipoObraPersonal].nPeopleM}
                              {...register(`${tipoObraPersonal}.nPeopleM`, {
                                min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                              })}
                            />
                            <ErrorMessage errors={errors} name={`${tipoObraPersonal}.nPeopleM`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                          </Form.Group>
                        </Form.Row>

                        <Form.Row>
                          <Form.Group as={Col} xs={12} md controlId={`[${tipoObraPersonal}]-nPeopleF`}>
                            <Form.Label>{"Nº de mujeres"}</Form.Label>
                            <Form.Control
                              isInvalid={errors[tipoObraPersonal] && errors[tipoObraPersonal].nPeopleF}
                              name={`${tipoObraPersonal}.nPeopleF`}
                              type="number"
                              {...register(`${tipoObraPersonal}.nPeopleF`, {
                                min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                              })}
                            />
                            <ErrorMessage errors={errors} name={`${tipoObraPersonal}.nPeopleF`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                          </Form.Group>
                        </Form.Row>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Col>
            );
          })}
        </Row>
      </Container>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormPersonal;
